import {
    Component,
    HostBinding,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import {ConclusionInfo, TechnicalDeviceElement} from '@models/technical-device-element';
import {ConclusionApiService} from '@api/conclusion.api.service';
import {EventsService} from '@services/events.service';
import {UserNamespace} from '@namespaces/user.namespace';
import {AuthService} from '@services/auth.service';
import {TechnicalDeviceDataService} from '../../services/technical-device-data.service';
import {TechnicalDeviceElementApiService} from '@api/technical-device-element.api.service';
import {AjaxDownloadService} from '@components/ajax-download-noty/ajax-download.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-element-list-item',
    templateUrl: './element-list-item.component.html',
    styleUrls: ['./element-list-item.component.scss']
})
export class ElementListItemComponent implements OnInit, OnDestroy {
    @Input() element: TechnicalDeviceElement;

    @Input() isFetching = false;

    @HostBinding('class') private className = 'tab-list-item';

    permissions = UserNamespace.Permission;

    constructor(
        public conclusionApi: ConclusionApiService,
        private events: EventsService,
        private authService: AuthService,
        private dataService: TechnicalDeviceDataService,
        private elementApi: TechnicalDeviceElementApiService,
        private ajaxDownloadService: AjaxDownloadService,
    ) {
    }

    ngOnInit() {

    }

    downloadConclusion(conclusion: ConclusionInfo) {
        conclusion.downloadButtonState$ = this.ajaxDownloadService.do({
            url: this.conclusionApi.getDocumentGeneratePath(conclusion.id),
            currentQueue: conclusion.downloadButtonState$,
            taskName: 'Заключение'
        });
    }

    removeConclusion(itemId: number) {
        if (!itemId) {
            return;
        }

        this.events.showConfirm({
            title: 'Вы уверены, что хотите удалить заключение?',
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.conclusionApi.delete({
                id: itemId
            }).subscribe(() => {
                this.dataService.conclusionRemoved$.next();

                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.conclusionRemovedMessage,
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.conclusionRemovedFailMessage,
                });
            });
        }, () => {});
    }

    onRemoveClick() {
        const conclusionsNumbers = this.element.conclusions.map(c => `«${c.numberTitle}»`);

        const title = `Вы уверены, что хотите удалить элемент${conclusionsNumbers.length ? ' и все связанные с ним заключения' : ''}?`;
        const message = `${conclusionsNumbers.length ? `Заключения ${conclusionsNumbers.join(', ')} будут удалены. ` : ''}` +
            'Отменить изменения будет невозможно';

        this.events.showConfirm({
            title,
            message,
            confirmButtonTitle: 'Удалить',
        }).subscribe(() => {
            this.elementApi.delete({
                id: this.element.id
            }).subscribe(() => {
                this.dataService.elementRemoved$.next();
                this.events.showNoty({
                    type: 'success',
                    content: NotyMessagesEnum.technicalDeviceElementRemovedMessage,
                });
            }, () => {
                this.events.showNoty({
                    type: 'error',
                    content: NotyMessagesEnum.technicalDeviceElementRemovedFailMessage,
                });
            });
        }, () => {});
    }

    ngOnDestroy() {
        this.element.conclusions.forEach(con => {
            if (con.downloadButtonState$) {
                con.downloadButtonState$.complete();
            }
        });
    }
}
